import { createAsyncThunk } from '@reduxjs/toolkit';
import { createEmployment, getEmployment, getEmployments, updateEmployment, uploadEmploymentFile } from '../api/employmentsApi';
import { showAlert } from '../slices/alertsSlice';
import { setCurrentEmployment, setEmploymentsList, setTentativeEmployment } from '../slices/employmentsSlice';
import { handleError } from '../slices/errorsSlice';
import { startLoading, endLoading } from '../slices/loadingSlice';

export const getEmploymentsList = createAsyncThunk('employments/getEmploymentsList', ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getEmployments(token, query)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setEmploymentsList({ employments: data.employments })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const getCurrentEmployment = createAsyncThunk('employments/getCurrentEmployment', ({ id }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getEmployment(token, id)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setCurrentEmployment({ employment: data.employment })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const createNewEmployment = createAsyncThunk('employments/createNewEmployment', ({ employment, callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  createEmployment(token, employment)
  .then(response => response.status === 201 ? response.json() : Promise.reject(response))
  .then(data => callback(data.employment))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const updateCurrentEmployment = createAsyncThunk('employments/updateCurrentEmployment', ({ id, employment }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  updateEmployment(token, id, employment)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setCurrentEmployment({ employment: data.employment })))
  .then(() => dispatch(showAlert({ message: 'Empleado actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const uploadCurrentEmploymentFile = createAsyncThunk('employees/uploadCurrentEmploymentFile', ({ id, employeeId, file }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  uploadEmploymentFile(token, id, file)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(getEmploymentsList({ query: employeeId })))
  .then(() => dispatch(showAlert({ message: 'Archivo actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const findTentativeEmployment = createAsyncThunk('employments/findTentativeEmployment', ({ query }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getEmployments(token, query)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => data.employments)
  .then(employments => employments?.length > 0 ? dispatch(setTentativeEmployment({ employment: employments[0] })) : null)
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});
